import { render } from "./reportClassV1.vue?vue&type=template&id=37617354&scoped=true"
import script from "./reportClassV1.vue?vue&type=script&lang=js"
export * from "./reportClassV1.vue?vue&type=script&lang=js"

import "./reportClassV1.vue?vue&type=style&index=0&id=37617354&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37617354"]])

export default __exports__